import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getNetworkState, NetworkError, networkInitialState, NetworkStatuses } from 'store/network';
import { CategoriesListingState, TSLPData } from './types';
import { sliceKey as name } from './utils';

const initialState: CategoriesListingState = {
	data: {
		configurators: [],
		deadlines: null,
		isCompensationEnabled: false,
	},
	network: networkInitialState,
};

export const ServicesListingSlice = createSlice({
	name,
	initialState,
	reducers: {
		fetchCategoriesRequest(state) {
			state.network = getNetworkState(NetworkStatuses.REQUEST);
		},
		fetchCategoriesSuccess(state, action: PayloadAction<{ data: TSLPData }>) {
			const { data } = action.payload;
			state.data = data;
			state.network = getNetworkState(NetworkStatuses.SUCCESS);
		},
		fetchCategoriesFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.network = getNetworkState(NetworkStatuses.FAILED, error);
		},
	},
});

export const {
	actions: categoriesListingActions,
	reducer: categoriesListingReducer,
	name: categoriesListingName,
} = ServicesListingSlice;

export const {
	fetchCategoriesRequest,
	fetchCategoriesFailed,
	fetchCategoriesSuccess,
} = categoriesListingActions;

export const categoriesListingState = initialState;
